import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

/**
 * ImpersonationBanner — persistent top bar shown ONLY while an admin is in a
 * read-only "View as Coach" session. Makes it unmistakable whose portal is on
 * screen and offers a one-click return to the admin account.
 */
const ImpersonationBanner = () => {
  const { user, impersonation, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!impersonation?.active) return null;

  const coachName = (user && typeof user === 'object' && user.name) || 'Coach';

  const handleReturn = async () => {
    await stopImpersonation();
    navigate('/admin/coaches', { replace: true });
  };

  return (
    <div
      className="sticky top-0 z-[9999] w-full bg-[#B45309] text-white shadow-md"
      data-testid="impersonation-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-sm font-bold">
          <Eye size={16} className="shrink-0" />
          <span data-testid="impersonation-banner-text">
            Viewing as <span className="font-black">{coachName}</span>{' '}
            <span className="font-semibold text-amber-100">— read-only. Coach actions are disabled.</span>
          </span>
        </div>
        <button
          type="button"
          onClick={handleReturn}
          className="inline-flex items-center gap-1.5 rounded-full bg-white text-[#B45309] px-3 py-1.5 text-xs font-black uppercase tracking-widest hover:bg-amber-50 transition-colors"
          data-testid="impersonation-return-btn"
        >
          <LogOut size={14} /> Return to Admin
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
